import { render, staticRenderFns } from "./ComparisonDialog.vue?vue&type=template&id=591bf152&"
import script from "./ComparisonDialog.vue?vue&type=script&lang=js&"
export * from "./ComparisonDialog.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonDialog.vue?vue&type=style&index=0&id=591bf152&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDialog,VFlex,VLayout})
